<template>
    <div class="home">
    <van-row class="bannar">
      <van-col span="24" class="bannar-box">
        <div>
            <van-swipe :autoplay="3000" lazy-render style="width:100%">
            <van-swipe-item v-for="(image, index) in images" :key="index" style="width:100%">
                <img style="width:100%" :src="image" />
            </van-swipe-item>
            </van-swipe>
        </div>
        <div class="bannar-content">
            <div>
                {{classData.class_name}}
            </div>
            <div>
                班级编号：{{classData.invitation_code}}
            </div>
            
        </div>

        <div class="class-content">
            <div>
                班级教师：{{classData.teacher_name}}
            </div>
            <div>
                <span>
                    班级有效期：{{classData.expiration_flag == 'N' ? '长期有效' : classData.expiration_datetime}}
                </span>
                <span>
                    我的有效期：{{classData.user_expiration_flag == 'N' ? '长期有效' : classData.user_expiration_datetime}}
                </span>
            </div>
            
        </div>
        <div class="bannar-btn-div">
            <el-popover
            placement="right"
            width="400"
            trigger="click"
             v-model="classPopver">
           <el-card class="box-card">
            <div class="inner-container">
                <div v-for="(item,index) in classList" :key="index" class="change-class-div" @click="changeClass(item)">
                    {{item.class_name }}
                </div>
            </div>
           
            </el-card>
            <span class="check-class-btn" slot="reference" >切换班级 <i class="el-icon-sort" style="transform: rotate(90deg)"></i></span>
            </el-popover>

            <span class="add-class-btn" @click="dialogVisible = true">添加班级 <i class="el-icon-plus" ></i></span>
        </div>
      </van-col>
    </van-row>
    <el-row id="m_app" v-cloak>
        <el-col :span="24">
            <div class="homepage">
				<el-row type="flex" justify="center" class="section">
					<el-col :xl="16" :lg="20" :md="22" :sm="22" :xs="22">
                        <el-row>
                            <el-col :span="24">
                                <div class="homepage-interview-title animate__animated animate__fadeInUp">
                                    <span>一体化学习模式</span>
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="homepage-interview-label animate__animated animate__fadeInUp">自主研发、系统稳定、优质服务</div>
                            </el-col>
                            <el-col :span="24">
                                <el-row>
                                    <el-col :xl="6" :lg="6"  :sm="24" :xs="24" v-for="(item, index) in abilityMap" :key="index">
                                        <div class="ability-box">
                                            <div class="ability-card" @click="skipRoute(item.tab)">
                                                <div>
                                                    <img :src="item.logo" alt="" style="width:40%">
                                                </div>
                                                <div class="ability-title">
                                                    {{item.title}}
                                                </div>
                                                <div class="ability-dec">
                                                    {{item.desc}}
                                                </div>
                                            </div>
                        
                                        </div>

                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
					</el-col>
				</el-row>

                <el-row type="flex" justify="center" class="section" style="margin-top:5vh">
					<el-col :xl="18" :lg="20" :md="22" :sm="22" :xs="22">
                        <el-row>
                                <el-col :span="12">
                                    <img src="http://foo.ibianma.com/jingying/word/2022/11/29/df0431b26339f5960a2f8db48803a4e3.png" alt="" style="width:100%">
                                </el-col>
                                <el-col :span="12">
                                    <div class="test-box">
                                        <div class="test-box-top-tab">

                                        </div>
                                        <div class="test-title">
                                            课堂练习
                                        </div>
                                        <div class="test-desc">
                                            学生利用课堂练习更有目的性、自主地学习。老师可以根据结果评估和判断，对学生进行个性化指导。课堂练习可以从字词句段篇等多方面体现教学目标的具体化要求，以检测各项目标的达成度。
                                        </div>
                                        <div class="test-btn" @click="skipRoute('EXERCISE')">
                                            立即练习>
                                        </div>
                                    </div>
                      
                                </el-col>
                        </el-row>
					</el-col>
				</el-row>
                <el-row type="flex" justify="center" class="section" style="margin-top:5vh">
					<el-col :xl="18" :lg="20" :md="22" :sm="22" :xs="22">
                        <el-row>
                            <el-col :span="12">
                                <div class="test-box">
                                    <div class="test-box-top-tab">

                                    </div>
                                    <div class="test-title">
                                        历年真题
                                    </div>
                                    <div class="test-desc">
                                        包含2017年至2022年N1、N2、历年真题。突破重点内容,反复练习真题,掌握更好更容易拿分。提高实战经验,提前体验高考的氛围，提高应试的实战经验
                                    </div>
                                    <div class="test-btn" @click="skipRoute('REALQUESTION')">
                                        立即练习>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <img src="http://foo.ibianma.com/jingying/word/2023/01/13/f2862b0103fd8935997e0d10986b2eb4.png" alt="" style="width:100%">
                            </el-col>
                        </el-row>
					</el-col>
				</el-row>
            </div>
        </el-col>
    </el-row>

    <el-dialog
    title="添加班级"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <el-form ref="form" :rules="joinClassFormRules"  :model="joinClassForm" label-width="100px">
        <el-form-item label="班级邀请码"  prop="invitation_code">
            <el-input v-model="joinClassForm.invitation_code" placeholder="请输入班级邀请码"></el-input>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="applyJoinClass">确 定</el-button>
    </span>
    </el-dialog>

    </div>
</template>

<script>
    import { userClassDetail, classMemberList, applyJoinClass} from '@/api'
    import store from '@/store'

    export default {
        name: 'JcclClass',
        props: ['cate', 'words'],
        data() {
            return {
                classPopver:false,
                dialogVisible: false,
                images: [
                    "http://foo.ibianma.com/jingying/word/2022/11/29/a704afba24fa95eca91bc97992a114c3.png"
                ],
                form:{
                    class_guid : -1
                },
                listForm:{
                        'page':1,
                        'limit':99,
                        'where':{}
                },
                joinClassForm:{
                    invitation_code:''
                },
                joinClassFormRules:{
                    invitation_code: [
                        { required: true, message: '请输入班级邀请码', trigger: 'blur' }
                    ],
                },
                classData:{},
                classList:[],
                abilityMap: [

                    {
                        title: '课后作业',
                        desc: '自由布置作业，随堂巩固，补全课上遗漏知识点',
                        logo: 'http://foo.ibianma.com/jingying/word/2022/11/29/b0f5d6fe50a8767632079188b88d1886.png',
                        tab:'HOMEWORK'
                    },
                    {
                        title: '考试中心',
                        desc: '班级考试，周考，月考，高效精准',
                        logo: 'http://foo.ibianma.com/jingying/word/2022/11/29/8322e53ff885989a96abe0fd9f78c2f6.png',
                        tab:'EXAMINATION'
                    },
                    {
                        title: '班级资源',
                        desc: '班内微课，课件，专辑永久支持随看随学',
                        logo: 'http://foo.ibianma.com/jingying/word/2022/11/29/a69c2134269156db9c8fc0cbd145eaaa.png',
                        tab:'CLASSSOURCE'
                    },
                    {
                        title: '活动中心',
                        desc: '玩乐中融入知识，让学习变得有趣而富有创造力',
                        logo: 'http://foo.ibianma.com/jingying/word/2024/11/19/f0742384769f29114870458021183caa.png',
                        tab:'ACTIVE'
                        
                    },
                ]
            }
        },
        components: {
        },
        computed: {
        },
        methods: {
            userClassDetail()
            {
                this.form.class_guid = this.$store.state.user.userInfo.class_guid
                userClassDetail(this.form).then(response => {

                    this.classData = response
                })
      
            },
            classMemberList()
            {
                classMemberList(this.listForm).then(response => {

                    this.classList = response.data
                    this.classData = this.classList[0]
                    for(const i  in this.classList)
                    {
                        if(this.classList[i].class_guid == this.$store.state.user.userInfo.class_guid)
                        {
                            this.classData = this.classList[i]
                        }
                        
                    }
                })
      
            },
            changeClass(item)
            {
                this.classPopver = false
                this.classData = item

                var userInfo = this.$store.state.user.userInfo
                userInfo.class_guid = item.class_guid
                
                store.dispatch('user/setUserInfoData', userInfo);
            },
            applyJoinClass()
            {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = false
                        applyJoinClass(this.joinClassForm).then(response => {
                            
                            if (response) {
                            this.$notify.success({
                                title: '信息提示',
                                message: response,
                                duration: 3000
                            })
                            this.classMemberList()
                            this.handleClose()
                            }
                        }).catch(() => {
                            this.dialogVisible = false
                        })
                    }
                })

            },
            handleClose()
            {
                this.dialogVisible = false
            },
            skipRoute(e)
            {
                switch(e) {
                    case 'EXAMINATION':
                        this.$router.push({path:'/examination',query: {class_guid:this.classData.class_guid}})
                        break;
                    case 'HOMEWORK':
                        this.$router.push({path:'/homework',query: {class_guid:this.classData.class_guid}})
                        break;
                    case 'EXERCISE':
                        this.$router.push({path:'/exercise',query: {class_guid:this.classData.class_guid}})
                        break;
                    case 'CLASSSOURCE':
                        this.$router.push({path:'/classsource',query: {class_guid:this.classData.class_guid}})
                    break;
                    case 'REALQUESTION':
                        this.$router.push({path:'/yearslist'})
                    break;
                    case 'ACTIVE':
                        this.$router.push({path:'/active'})
                    break;
                    
                    default:
                        
                } 
            }

        },
        mounted() {
            // this.userClassDetail()
            this.classMemberList()

        }
    }
</script>
<style scoped lang="less">

    .homepage{
        text-align: center;
    }
    .homepage-interview-title{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #282828;
        margin-top: 48px;
        font-family: AdobeHeitiStd-Regular;
        font-weight: normal;
        font-size: 24px;
        font-weight: bold;
    }

    .homepage-interview-label{
        width: 100%;
        margin-top: 14px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 26px;
        font-family: AdobeHeitiStd-Regular;
        font-weight: bold;
        color: #666666;
    }
    .bannar-box{
        width: 100%;
        font-size: 0px;
        position: relative;
    }
    .bannar-content{
        position: absolute;
        top: 11vw;
        left: 15vw;
        display: flex;
        flex-flow: column;
        font-size: 2.5vw;
        color: #ffffff;
        text-align: left;
 
    }



    .class-content{
        position: absolute;
        top: 21vw;
        left: 15vw;
        display: flex;
        flex-flow: column;
        font-size: 1vw;
        color: #ffffff;
        text-align: left;
    }
    .bannar-btn-div{
        position: absolute;
        top: 26vw;
        left: 14vw;
        flex-flow: column;
        font-size: 1vw;
        color: #409EFF;
        align-items: center;
        background-color:#47B5FC;
            padding: 10px 0;
        border-radius: 50px;
    }

    .check-class-btn{
        width: 17vw;
        color: #616D7E;
        background-color: #E2ECF1;
        text-align: center;
        // border: 1px solid #E2ECF1;
        border-radius: 50px;
        padding: 10px 60px;
        cursor: pointer;
    }

    .add-class-btn{
        width: 17vw;
        color: #616D7E;
        background-color: #47B5FC;
        text-align: center;
        // border: 1px solid #E2ECF1;
        color: #fff;
        border-radius: 50px;
        padding: 10px 50px;
        cursor: pointer;
    }

    .strip-tip{
        width: 6px;
        height: 37px;
        background: #18A5FF;
        border-radius: 3px;
        background: #18A5FF;
        margin-right: 14px;
    }

    .ability-box{
        padding:1vh 2vw;
    }

    .ability-card{
        border: 2px solid #53BBFC;
        background-color: #ffffff;
        padding: 4vh 1vw;
        // height:30vh;
        border-radius: 10px;
        box-shadow: 0px 4px 8px 0px rgba(83,187,252,0.48);
        cursor: pointer;
    }

    .ability-title{
        color:#282828;
        font-size:1vw;
        padding-top:20px;
    }

    .ability-dec{
        padding-top:30px;
        color:#666666;
        font-size:0.8vw;
    }

    .test-desc{
        padding-top:30px;
        color:#565D69;
        font-size:1vw;
        text-align: left;
    }
    .test-box{
        padding:0 10vh;
    }

    .test-title
    {
        width: 100%;
        display: flex;

        text-align: left;
        color: #282828;
        margin-top: 5vh;
        font-family: AdobeHeitiStd-Regular;
        font-weight: normal;
        font-size: 24px;
        font-weight: bold;
    }
    .test-btn{
        font-family: Source Han Sans CN;
        font-weight: 400;
        text-decoration: underline;
        color: #3F77E4;
        line-height: 30px;
         text-align: left;
         margin-top:10vh;
         cursor: pointer;
    }
    .test-box-top-tab{
        width: 1.5vw;
        height: 3px;
        background-color: #468BFE ;
        margin-top: 8vh;
    }

    .change-class-div{
        font-size: 14px;
        padding: 0 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .change-class-div:hover {
        background-color: #f5f7fa;
    }
    .inner-container{
        height:80vh;
        overflow:auto;
      
    }


    @media (max-width: 1400px) {
    .ability-card{
        border: 2px solid #53BBFC;
        background-color: #ffffff;
        padding: 4vh 1vw;
        // height:35vh;
        border-radius: 10px;
        box-shadow: 0px 4px 8px 0px rgba(83,187,252,0.48);
        cursor: pointer;
    }


    }

</style>
